import type {ReactNode} from 'react';
import {ToastContextValue, ToastOptions} from '../contexts/toast';

type Enqueue = ToastContextValue['toast'];

export const progressToast = (enqueue: Enqueue) => (id: string) => ({
    start: (message: string | ReactNode, options?: ToastOptions) => enqueue(message, { id, timeout: 0, ...options }),
    ok: (message: string | ReactNode, options?: ToastOptions) => enqueue(message, { id, variant: 'success', ...options }),
    fail: (message: string | ReactNode, options?: ToastOptions) => enqueue(message, { id, variant: 'error', ...options }),
});
